export default __webpack_public_path__ + "static/media/gmail_icon.ef0b155e.png";